import { render, staticRenderFns } from "./NotificationEvent.vue?vue&type=template&id=be9e918a&scoped=true&"
import script from "./NotificationEvent.vue?vue&type=script&lang=ts&"
export * from "./NotificationEvent.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationEvent.vue?vue&type=style&index=0&id=be9e918a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9e918a",
  null
  
)

export default component.exports